export const config = {
  serverURL: "https://u9k99h0hz4.execute-api.us-east-1.amazonaws.com/qa1/api/v1.0",
  NXTServerURL: "https://{tenant}.qa.mktnxt.com", // TODO: to be changed to NXT
  gaTrackingId: "UA-39909867-5",
  gaDebug: false,
  environment: "qa1",
  clientId: "9ep27lregumtmqbhrlntir7gf",
  cognitoDomain: "marketron-dev.auth.us-east-1.amazoncognito.com",
  identityProvider: "marketron-dev.com",
  launchDarklyClientId: "5da4c4dddc79f008b44ff6d6",
  uploadCreativeServerUrl: "https://radigio-alb-qa1.mediascape-dev.com/creative/api/v1.0/creatives",
  userPoolId: "us-east-1_s6bRlZd0d",
};
